const updateServices = {
  toastr: 'Service updated successfully',
  toastrError: 'Service already registered',
  toastrError1: 'Name already registered'
};

export default updateServices;
